"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _material = require("@mui/material");

var _ = require("../");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var InputDropdown = function InputDropdown(_ref) {
  var _TextFieldProps$Input;

  var children = _ref.children,
      label = _ref.label,
      _onClose = _ref.onClose,
      PopoverProps = _ref.PopoverProps,
      TextFieldProps = _ref.TextFieldProps,
      value = _ref.value;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorRef = (0, _react.useRef)(null);
  var popoverId = (0, _react.useMemo)(function () {
    return (0, _utilities.generateId)();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, _objectSpread(_objectSpread({
      label: label,
      onClick: function onClick() {
        return setOpen(!open);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          setOpen(!open);
        }
      },
      ref: anchorRef,
      value: value
    }, TextFieldProps), {}, {
      InputProps: _objectSpread(_objectSpread({
        endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputAdornment, {
          position: "end",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Icon, {
            iconName: "caret-down",
            mr: 1,
            size: "small"
          })
        }),
        sx: {
          cursor: "pointer"
        }
      }, TextFieldProps === null || TextFieldProps === void 0 ? void 0 : TextFieldProps.InputProps), {}, {
        inputProps: _objectSpread({
          "aria-expanded": open,
          "aria-haspopup": "dialog",
          "aria-owns": popoverId,
          "aria-readonly": "true",
          readOnly: true,
          role: "combobox",
          sx: {
            cursor: "pointer"
          }
        }, TextFieldProps === null || TextFieldProps === void 0 ? void 0 : (_TextFieldProps$Input = TextFieldProps.InputProps) === null || _TextFieldProps$Input === void 0 ? void 0 : _TextFieldProps$Input.inputProps)
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Popover, _objectSpread(_objectSpread({
      anchorEl: anchorRef.current,
      anchorOrigin: {
        horizontal: "left",
        vertical: "bottom"
      },
      elevation: 4,
      id: popoverId,
      marginThreshold: 0,
      onClose: function onClose(e, reason) {
        setOpen(false);

        if (_onClose) {
          _onClose(e, reason);
        }
      },
      open: open,
      role: "dialog"
    }, PopoverProps), {}, {
      children: children
    }))]
  });
};

var _default = InputDropdown;
exports.default = _default;